export const symbols = [
  "BTCUSD", "ETHUSD", "BNBUSD", "SOLUSD", "XRPUSD", "ADAUSD",
  "DOGEUSD", "DOTUSD", "MATICUSD", "LINKUSD", "UNIUSD", "AVAXUSD"
];

export const timeframes = [
  "1m", "3m", "5m", "15m", "30m", "1h", "2h", "4h", "6h", "12h", "1d", "3d", "1w"
];

export const strategies = [
  {
    id: "ema_crossover",
    name: "EMA Crossover",
    badge: "EMA Cross",
    badgeColor: "primary",
    description: "Configurable Fast/Slow EMA crossover — SL & Target fully user-controlled",
    documentation: {
      overview: "Fast EMA crosses ABOVE Slow EMA => BUY. Fast EMA crosses BELOW Slow EMA => SELL. Trade exits when Stop Loss (%) or Take Profit (%) is hit.",
      parameters: {
        "Fast EMA": "Short period EMA (default 9)",
        "Slow EMA": "Long period EMA (default 21)",
        "Confirm Candles": "Cross must hold N candles before entry",
        "Stop Loss %": "% drop from entry price -> auto exit LONG",
        "Take Profit %": "% rise from entry price -> auto exit LONG",
      },
      signals: {
        buy: "Fast EMA crosses above Slow EMA",
        sell: "Fast EMA crosses below Slow EMA",
      },
      bestFor: "Any market, any timeframe",
      riskLevel: "Medium",
    },
  },
];

export const STRATEGY_PRESETS = {};
